const zh_hant = {
  title: "提示",
  confirm: "確認",
  cancel: "取消",
  error: "出現了預料之外的錯誤",
  save: "保存",
  placeholder: "輸入",
  page: "頁",
  search: "搜索",
  close: "關閉",
  export: "匯出到",
  wait: "請稍等片刻",
  delete_tips: "該項目會被刪除",
  go_on: "繼續",
  tips: "貼士",
  add: "新建",
  select: "选择",
  grade: "年級",
  class: "班級",
  delete_mode: "刪除模式",
  operate_too_frequently: "操作太頻繁",
  upload: "上傳",
  delete: "刪除",
  date: "時間",
  nickname: "名稱",
  duration: "時長",
  edit: "編輯",
  index: "序號",
  operation: "操作",
  before_delete: "確定要刪除嗎",
  name: "姓名",
  year: "年",
  month: "月",
  day: "天",
  hour: "時",
  minute: "分",
  required: "此項必填",
  last_login_time: "最後登錄時間",
  filter: "篩選",
  recent: "最近",
  complete: "完成",
  keyword: "輸入關鍵字",
  area: "地區",
  accept: "接受",
  file: "文檔",
  jpg: "圖像",
  notFound: "當前頁面不存在",
  automatically: "後自動返回上一級",
  empty: "沒有內容",
  userError: "目前登入帳號無權限訪問",
  word: "字",
  drop: "拖動文件到這裡或者",
  click: "點擊選擇文件",
  fileTitle: "標題",
  tablet: "控制系統",
  idealab: "Idea Lab",
  openIdealab: "前往Idea Lab網站",
  openTablet: "前往控制系統",
  expand: "更多選項",
  packup: "收起選項",
  searchByName: "根據電郵搜索",
  excel: "導出到Excel",
  exportNothing: "現在沒有數據可以導出",
  helpText: "點我，告訴你怎麼使用",
  recentExplain: "查看最近三天創建的教案",
  startTime: "起始時間",
  endTime: "結束時間",
  yes: "是",
  no: "否",
  value: "值",
  placeholder2: "填寫公式"
};
const zh_cn = {
  title: "提示",
  confirm: "确认",
  cancel: "取消",
  error: "出现了预料之外的错误",
  save: "保存",
  placeholder: "输入",
  page: "页",
  search: "搜索",
  close: "关闭",
  export: "导出到",
  wait: "请稍等片刻",
  delete_tips: "该项目会被删除",
  go_on: "继续",
  tips: "贴士",
  add: "新建",
  select: "选择",
  grade: "年级",
  class: "班级",
  delete_mode: "删除模式",
  operate_too_frequently: "操作太频繁",
  upload: "上传",
  delete: "删除",
  date: "时间",
  nickname: "名称",
  duration: "时长",
  edit: "编辑",
  index: "序号",
  operation: "操作",
  before_delete: "确定要删除吗",
  name: "姓名",
  year: "年",
  month: "月",
  day: "天",
  hour: "时",
  minute: "分",
  required: "此项必填",
  last_login_time: "最后登录时间",
  filter: "筛选",
  recent: "最近",
  complete: "完成",
  keyword: "输入关键字",
  area: "地区",
  accept: "接受",
  file: "文档",
  jpg: "图像",
  notFound: "当前页面不存在",
  automatically: "后自动返回上一级",
  empty: "没有内容",
  userError: "目前登入账号无权限访问",
  word: "字",
  drop: "拖动文件到这里或者",
  click: "点击选择文件",
  fileTitle: "标题",
  tablet: "控制系统",
  idealab: "Idea Lab",
  openIdealab: "前往Idea Lab网站",
  openTablet: "前往控制系统",
  expand: "更多选项",
  packup: "收起选项",
  searchByName: "根据邮箱搜索",
  excel: "导出到Excel",
  exportNothing: "现在没有数据可以导出",
  helpText: "点我，告诉你怎么使用",
  recentExplain: "查看最近三天创建的教案",
  startTime: "起始时间",
  endTime: "结束时间",
  yes: "是",
  no: "否",
  value: "值",
  placeholder2: "填写公式"
};
const en = {
  title: "Notice",
  confirm: "Confirm",
  cancel: "Cancel",
  page: " page(s)",
  error: "Something Unexpected Happened",
  save: "Save",
  placeholder: "Input",
  search: "Search",
  close: "Close",
  export: "Export to",
  nickname: "Name",
  wait: "Please Wait",
  delete_tips: "The item will be deleted",
  go_on: "Continue",
  tips: "Tips",
  add: "Add",
  select: "Select",
  class: "Class",
  delete_mode: "Delete Mode",
  grade: "Grade",
  operate_too_frequently: "Operate too frequently",
  upload: "Upload file",
  delete: "Delete",
  date: "Time",
  jpg: "image",
  index: "Serial",
  duration: "Duration",
  operation: "Operation",
  edit: "Edit",
  before_delete: "Are you sure you want to delete",
  name: "Name",
  year: "years",
  month: "months",
  day: "days",
  hour: "hours",
  minute: "minutes",
  required: "This item is required",
  last_login_time: "Last login time",
  filter: "Filter",
  complete: "Done",
  keyword: "Input keyword",
  area: "Area",
  notFound: "The current page does not exist",
  automatically: "Automatically return to the previous level after ",
  empty: "Empty",
  word: "words",
  accept: "Accept ",
  userError: "The current login account does not have permission to access",
  drop: "Drop file here or ",
  file: " file",
  click: "click to upload",
  fileTitle: "Title",
  tablet: "Control Panel",
  idealab: "Idea Lab",
  openIdealab: "Go to Idea Lab website",
  openTablet: "Go to Control Systems",
  expand: "expand more",
  packup: "pack up",
  searchByName: "Find by mail",
  excel: "Export to Excel",
  recent: "Recent",
  recentExplain: "Filter the lesson plans created in the past three days",
  exportNothing: "There is currently no data available for export",
  helpText: "Click on me and I'll tell you how to use it",
  startTime: "Starting time",
  endTime: "End time",
  yes: "Yes",
  no: "No",
  value: "value",
  placeholder2: "Fill in the formula"
};

const es = {
  title: "Aviso",
  confirm: "Confirmar",
  cancel: "Cancelar",
  error: "Ha ocurrido un error inesperado",
  save: "Guardar",
  placeholder: "Entrada",
  page: "página(s)",
  search: "Buscar",
  close: "Cerrar",
  export: "Exportar a",
  wait: "Por favor, espera",
  delete_tips: "El elemento será eliminado",
  go_on: "Confirmar",
  tips: "Consejos",
  add: "Agregar",
  select: "Selección",
  grade: "Grado",
  class: "Clase",
  delete_mode: "Modo de eliminación",
  operate_too_frequently: "Operar con demasiada frecuencia",
  upload: "Subir",
  delete: "Eliminar",
  date: "Tiempo",
  nickname: "Nombre",
  duration: "Duración",
  edit: "Editar",
  index: "Número de serie",
  operation: "Operación",
  before_delete: "¿Estás seguro de que deseas eliminar?",
  name: "Nombre",
  year: "años",
  month: "meses",
  day: "días",
  hour: "horas",
  minute: "minutos",
  required: "Este campo es obligatorio",
  last_login_time: "Última hora de inicio de sesión",
  filter: "Filtrar",
  recent: "Recientes",
  complete: "Hecho",
  keyword: "Ingresar palabra clave",
  area: "Área",
  accept: "Aceptar",
  file: "Documentos",
  jpg: "Imagen",
  notFound: "La página actual no existe",
  automatically: "Volver automáticamente al nivel anterior",
  empty: "Sin contenido",
  userError: "La cuenta de inicio de sesión actual no tiene permiso para acceder",
  word: "palabras",
  drop: "Arrastre el archivo aquí o",
  click: "Haga clic para seleccionar el archivo",
  fileTitle: "Título",
  tablet: "Panel de control",
  idealab: "Idea Lab",
  openIdealab: "Ir al sitio web de Idea Lab Lab網站",
  openTablet: "Ir a los sistemas de control",
  expand: "más opciones",
  packup: "ocultar opciones",
  searchByName: "Buscar por correo electrónico",
  excel: "Exportar a Excel",
  exportNothing: "Actualmente no hay datos disponibles para exportar",
  helpText: "Haz clic en mí y te diré cómo usarlo",
  recentExplain: "Filtrar los planes de lecciones creados en los últimos tres días",
  startTime: "Hora de inicio",
  endTime: "Hora de fin",
  yes: "Sí",
  no: "No",
  value: "valor",
  placeholder2: "Llena el formulario"
};
export default {
  zh_hant,
  en,
  es,
  zh_cn
};
